/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RouterConfig = undefined;

var _premissionAuth = require('../utils/premissionAuth.jsx');

var _containers = require('../containers');

var checkToken = function checkToken(nextState, replace, next) {
  var token = localStorage.getItem('token');
  var cToken = (0, _premissionAuth.getToken)();
  var oneToken = cToken ? cToken : token;
  if (oneToken) {
    next();
  } else {
    replace('/login');
    next();
  }
};

var RouterConfig = exports.RouterConfig = [{

  path: '/',
  component: _containers.App,
  breadcrumbName: '首页',
  indexRoute: { component: _containers.ProductList, onEnter: checkToken },
  childRoutes: [{
    path: 'login',
    component: _containers.Login,
    breadcrumbName: '登录'
  }, {
    onEnter: checkToken,
    path: 'edit',
    component: _containers.ProductEdit,
    breadcrumbName: '新增车辆'
  }, {
    onEnter: checkToken,
    path: '/equipment',
    component: _containers.ProductEquipment,
    breadcrumbName: '新增产品'
  }, {
    onEnter: checkToken,
    path: 'equipment/:id',
    component: _containers.ProductEquipment,
    breadcrumbName: '编辑设备'
  }, {
    onEnter: checkToken,
    path: 'edit/:id',
    component: _containers.ProductEdit,
    breadcrumbName: '编辑产品'
  },
  // {
  //   onEnter: checkToken,
  //   path: 'sbdevice',
  //   component: Sbdevice,
  //   breadcrumbName: '产品详情'
  // },
  {
    path: 'product/:id',
    breadcrumbName: '产品概况',
    component: _containers.Layout,
    indexRoute: { component: _containers.ProductDetail, onEnter: checkToken }
  }, {
    path: 'device',
    breadcrumbName: '设备管理',
    component: _containers.Layout,
    childRoutes: [{
      onEnter: checkToken, path: 'detail/:id/:eid', breadcrumbName: '车辆详情', component: _containers.DeviceDetail
    }, {
      onEnter: checkToken, path: 'sbdevice/:id/:bid/:did', breadcrumbName: '设备详情', component: _containers.Sbdevice
    }, {
      onEnter: checkToken, path: 'batteryinfo/:id/:bid/:did/:batteryCabinetNum/:type', breadcrumbName: '电池仓详情', component: _containers.BatteryInfo
    }, { onEnter: checkToken, path: 'insert/:id', breadcrumbName: '新增设备', component: _containers.InsertDevice }, { onEnter: checkToken, path: 'index/:id', breadcrumbName: '', component: _containers.DeviceIndex }, { onEnter: checkToken, path: 'index/:id/:did', breadcrumbName: '', component: _containers.DeviceIndex }]
  }, {
    path: 'batterymanagement',
    breadcrumbName: '电池管理',
    component: _containers.Layout,
    childRoutes: [{
      onEnter: checkToken,
      path: 'index/:id',
      breadcrumbName: '',
      component: _containers.BatteryManagement
    }, {
      onEnter: checkToken,
      path: 'batdetail/:id/:bid',
      breadcrumbName: '电池详情',
      component: _containers.BatDetail
    }]
  }, {
    path: 'remote/:id',
    breadcrumbName: '版本信息',
    component: _containers.Layout,
    indexRoute: { component: _containers.RemoteIndex, onEnter: checkToken },
    childRoutes: [{
      onEnter: checkToken,
      path: 'update',
      breadcrumbName: '版本升级',
      component: _containers.RemoteUpdate
    }, {
      onEnter: checkToken,
      path: 'reupgrad/:rid',
      breadcrumbName: '版本升级',
      component: _containers.RemoteUpdate
    }, {
      onEnter: checkToken,
      path: 'records',
      breadcrumbName: '升级记录',
      component: _containers.Records
    }, {
      onEnter: checkToken,
      path: 'recordsDetail/:rid',
      breadcrumbName: '升级详情',
      component: _containers.RecordsDetail
    }, {
      onEnter: checkToken,
      path: 'version',
      breadcrumbName: ' 版本分布',
      component: _containers.RemoteVersion
    }, {
      path: 'updateByStation',
      breadcrumbName: '按站点升级',
      indexRoute: { component: _containers.UpdateByStation, onEnter: checkToken },
      childRoutes: [{
        onEnter: checkToken,
        path: 'update/:uid',
        breadcrumbName: '版本升级',
        component: _containers.RemoteUpdate
      }]
    }]
  }, {
    path: 'version',
    breadcrumbName: '升级包管理',
    component: _containers.Layout,
    childRoutes: [{
      onEnter: checkToken, path: 'insertVersion/:id', breadcrumbName: '新增升级包', component: _containers.InsertVersion
    }, { onEnter: checkToken, path: 'index/:id', breadcrumbName: '', component: _containers.VersionIndex }]
  }, {
    path: 'parts',
    breadcrumbName: '部件管理',
    // component: Layout,
    childRoutes: [{
      onEnter: checkToken, path: 'insertVersion', breadcrumbName: '部件管理', component: _containers.InsertVersion
    }, { onEnter: checkToken, path: 'index', breadcrumbName: '', component: _containers.Parts }]
  }, {
    path: 'channel',
    breadcrumbName: '渠道管理',
    component: _containers.Layout,
    childRoutes: [{
      onEnter: checkToken, path: 'insertVersion/:id', breadcrumbName: '渠道管理', component: _containers.InsertVersion
    }, { onEnter: checkToken, path: 'index/:id', breadcrumbName: '', component: _containers.Channel }]
  }, {
    path: '*',
    component: _containers.NoMatch
  }]
}];

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/routes/index.jsx
// module id = 329
// module chunks = 0